import React, { ReactNode, useRef } from 'react';
import useRovingMessageList from 'flow/hooks/useRovingMessageList';

/**
 * Holds the message a thread belongs to, above the replies. It is a message
 * row like the ones in the lists, so it runs the same list hook over itself:
 * Tab reaches it, it is announced, and Enter opens its controls.
 */
const ThreadParentMessage = ({ children }: { children: ReactNode }) => {
    const ref = useRef<HTMLDivElement>(null);
    const rovingHandlers = useRovingMessageList(ref);

    return (
        <div ref={ref} {...rovingHandlers}>
            {children}
        </div>
    );
};

export default ThreadParentMessage;
